import { HttpErrorResponse } from '@angular/common/http';
import { NzMessageService } from 'ng-zorro-antd/message';

const DEFAULT_TIMEOUT_MESSAGE = 'Export is taking too long. Please reduce the selected time period.';
const DEFAULT_ERROR_MESSAGE = 'Download failed. Please try again and reach out for support if the issue persists.';

export function createDownloadErrorHandler(messageService: NzMessageService, timeoutMessage?: string) {
  return (err: unknown) => {
    console.error('Download failed:', err);
    if (err instanceof HttpErrorResponse && (err.status === 408 || err.status === 504)) {
      messageService.error(timeoutMessage ?? DEFAULT_TIMEOUT_MESSAGE);
    } else {
      messageService.error(DEFAULT_ERROR_MESSAGE);
    }
  };
}
